import React from "react";
import {
  DriverSocketActionsType,
  DriverSocketStateSelectorType,
  useDriverSocketActions,
  useDriverSocketState
} from "./hooks";

type MapDriverSocketActionsType = (actions: DriverSocketActionsType) => any;

export const withDriverSocket = (
  mapSocketStateToProps?: DriverSocketStateSelectorType,
  mapSocketActionsToProps?: MapDriverSocketActionsType
) => (BaseComponent: React.Component) => (props: any) => {
  const socketState = useDriverSocketState(mapSocketStateToProps);
  const socketActions = useDriverSocketActions();
  return (
  // @ts-ignore
    <BaseComponent
      {...props}
      {...(mapSocketStateToProps ? socketState : {})}
      {...(mapSocketActionsToProps ? mapSocketActionsToProps(socketActions) : {})}
    />
  )
}

